<style lang="scss" scoped>
.image,
.fake-image {
    height: 130px;
    width: 130px;
    border-radius: 50%;
}

.fake-image,
.fake-name,
.fake-text,
.fake-line {
    background: #d8dee1;
    display: block;
}
.fake-name {
    height: 15px;
    width: 50%;
}
.fake-text {
    height: 15px;
    width: 70%;
}
</style>

<template>
    <div class="bg-light p-40 rounded-sm mb-24 text-center flex flex-col items-center">
        <template v-if="loading">
            <div class="fake-image mb-16"></div>
            <div class="fake-text mb-16"></div>
            <div class="fake-name"></div>
        </template>
        <template v-else-if="success">
            <img class="image mb-16 object-cover" :src="contact.image" alt="" />
            <div class="text-dark font-mon font-bold text-h5 mb-8 text-center">Solliciteren</div>
            <a class="text-p text-dark font-mon" href="mailto:info@step2work.be">info@step2work.be</a>
        </template>
        <template v-else>
            <div class="text-dark font-mon font-bold text-h5 mb-8 text-center">Solliciteren</div>
            <a class="text-p text-dark font-mon" href="mailto:info@step2work.be">info@step2work.be</a>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        email: {
            required: true,
            type: String
        },
        name: {
            required: true,
            type: String
        }
    },

    data: () => ({
        contact: null,
        loading: false,
        success: false
    }),

    mounted() {
        this.fetch();
    },

    methods: {
        fetch() {
            this.loading = true;
            this.success = false;
            axios
                .get("/api/assignees", { params: { email: this.email } })
                .then(response => this.handleFetch(response.data))
                .finally(() => (this.loading = false));
        },
        handleFetch(data) {
            if (data.success) {
                this.contact = data.data;
                this.success = true;
            }
        }
    }
};
</script>
